import { Component } from '@angular/core';
import { creationNavRoutes } from './routes';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'md-creation-home-page',
  imports: [RouterLink, MatIconModule],
  templateUrl: './creation-home-page.component.html',
  styleUrl: './creation-home-page.component.scss'
})
export class CreationHomePageComponent {
  routes = creationNavRoutes;
}
